<div
  class="c-blockHeader"
  [ngClass]="modifier"
  [class.c-blockHeader--first]="isHeaderFirst"
>
  <!-- Title Section -->
  <ng-container *ngIf="titleTemplate; else defaultTitleTemplate">
    <div class="c-blockHeader__info">
      <h2 class="t-title c-blockHeader__title">
        <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
      </h2>
    </div>
  </ng-container>

  <ng-template #defaultTitleTemplate>
    <div *ngIf="title" class="c-blockHeader__info">
      <h2 class="t-title c-blockHeader__title">{{ title }}</h2>
    </div>
  </ng-template>

  <!-- Forms Section -->
  <div
    *ngIf="showForms && formsTemplate"
    class="c-blockHeader__forms forms-container"
  >
    <ng-container *ngTemplateOutlet="formsTemplate"></ng-container>
  </div>

  <!-- Content Section -->
  <div *ngIf="contentTemplate" class="c-blockHeader__content">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>

  <!-- Tools Section -->
  <div *ngIf="toolsTemplate" class="c-blockHeader__tools">
    <ng-container *ngTemplateOutlet="toolsTemplate"></ng-container>
  </div>
</div>
